
import { Box, BoxProps, styled } from '@mui/material'

export const Center = styled(Box, { shouldForwardProp: props => props !== 'ha' && props !== 'va'})<BoxProps & { ha?: "start" | "center" | "end", va?: "start" | "center" | "end" }>(({ ha, va, theme }) => ({
    display: 'flex',
    justifyContent: ha ? ha : 'center',
    alignItems: va ? va : 'center'
}));

export default Center;